export const DataMutationMyBag_PromoCodeRemove_QueryKey = {
  mybagPromoCodeRemove: (): string => {
    const queryKey = "data-mutation-mybag-promo-code-remove";
    return queryKey;
  },
};
